module.exports = __webpack_public_path__ + "static/media/600.68a42380.webp";